import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import { ApiClient } from "../../api/ApiClient";

import { Form, Modal, Typography, Tag, Tabs, TabPane } from "@douyinfe/semi-ui";
import { formatFloat, formatDate } from "../../utils";
import React, { useState, useEffect } from "react";
import LeadReportItem from "./leadReportItem";
import { LeadReportItemProps } from "./leadReportItem";
import {IconUserGroup, IconUser, IconModalStroked} from "@douyinfe/semi-icons";

const apiClient = ApiClient.getDefault();
export default function AssignVisitStatDate() {
  const [crudApi, setCrudApi] = useState(undefined as undefined | CrudApi);
  const [showLeadItemModal, setShowLeadItemModal] = useState(false);
  const [leadReportItemProps, setLeadReportItemProps] = useState(
    undefined as undefined | LeadReportItemProps
  );

  const username = localStorage.getItem("username");
  let cols: Col[] = [
    {
      name: "名称",
      width: 200,
      showInFilter: false,
      key: "name",
      type: ColType.STRING,
      render: (value, record, index) => {
        if (record.type == "org") {
          return (
            <Typography.Text strong type="warning">
              {value}
            </Typography.Text>
          );
        } else {
          return <Typography.Text strong>{value}</Typography.Text>;
        }
      },
    },

    {
      name: "新客分配数",
      width: 100,
      key: "assignCount",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "assign",
                record.type,
                -1,
                record.name,
                record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "上门数",
      width: 80,
      key: "visitCount",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "visit",
                record.type,
                -1,
                record.name,
                record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "0星",
      width: 80,
      key: "star0",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "visit",
                record.type,
                0,
                record.name,
                record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "1星",
      width: 80,
      key: "star1",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "visit",
                record.type,
                1,
                record.name,
                record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "2星",
      width: 80,
      key: "star2",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "visit",
                record.type,
                2,
                record.name,
                record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "3星",
      width: 80,
      key: "star3",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "visit",
                record.type,
                3,
                record.name,
                record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "4星",
      width: 80,
      key: "star4",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "visit",
                record.type,
                4,
                record.name,
                record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },

    {
      name: "5星",
      width: 80,
      key: "star5",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModal(
                record.realId,
                "visit",
                record.type,
                5,
                record.name,
                record.city
              );
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "成本",
      width: 80,
      key: "cost",
      type: ColType.NUMBER,
    },
    {
      name: "费用",
      width: 80,
      key: "costAccumulation",
      type: ColType.NUMBER,
    },

    {
      name: "城市",
      key: "city",
      colSort: 2,
      hideInList: true,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },
    {
      name: "销售",
      key: "saleIds",
      colSort: 3,
      hideInCreate: true,
      showInFilter: true,
      hideInList: true,
      type: ColType.TREE_MUL,
      getOptions: () => apiClient.getTeamMemberTreeAsOpts(username),
    },
    {
      name: "日期",
      key: "createdAt",
      hideInList: true,
      showInFilter: true,
      type: ColType.DATE_RANGE,
    },
    {
      name: "团队",
      key: "teamId",
      type: ColType.TREE,
      getOptions: (row) => apiClient.getTeamAsOpts(),
      hideInList: true,
      showInFilter: true,
    },
  ];

  let nowDate = new Date();
  let nowDateStr = formatDate(nowDate);
  const city = localStorage.getItem("city");
  const [initFilterValues, setInitFilterValues] = useState({
    createdAt: [nowDate, nowDate],
    city:city,
  });

  const initParams = {
    createdAt: nowDateStr + "," + nowDateStr,
    city:city,
  };

  const openLeadItemModal = async (
    id: number,
    dataType: string,
    type: string,
    star: number,
    name: string,
    city: string
  ) => {
    let queryParams = crudApi?.getQueryParams();
    let createdDate;
    if (type != "org") {
      createdDate = name;
    }
    let p: LeadReportItemProps = {
      reportType: "StatAssignVisit",
      dataType: dataType,
      ...queryParams,
      city: city,
      star: star,
      createdDate: createdDate,
      otherCondition: "teamUsers",
    };
    setLeadReportItemProps(p);
    setShowLeadItemModal(true);
  };

  return (
    <>
      <Tabs type="line" style={{ margin: 10 }}>
        <TabPane
          tab={
            <span>
              <IconUserGroup />
              团队日期纬度
            </span>
          }
          itemKey="1"
        >
          <Modal
              icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
            fullScreen
            title="客户列表"
            visible={showLeadItemModal}
            hasCancel={false}
            onCancel={() => setShowLeadItemModal(false)}
            okType="tertiary"
            okText="关闭"
            onOk={() => setShowLeadItemModal(false)}
              contentStyle={{ overflow: 'auto' }}
              bodyStyle={{
                height: '100%',
                padding: 0,
                overflow: 'hidden' // 父级隐藏滚动条，由内容自己管理
              }}
          >
            <LeadReportItem
              reportType={leadReportItemProps?.reportType}
              dataType={leadReportItemProps?.dataType}
              createdAt={leadReportItemProps?.createdAt}
              teamId={leadReportItemProps?.teamId}
              saleIds={leadReportItemProps?.saleIds}
              city={leadReportItemProps?.city}
              star={leadReportItemProps?.star}
              createdDate={leadReportItemProps?.createdDate}
              otherCondition={leadReportItemProps?.otherCondition}
            ></LeadReportItem>
          </Modal>
          <Crud
            getCrudApi={(crudApi) => {
              setCrudApi(crudApi);
            }}
            name="团队日期KPI报表"
            initFilterValues={initFilterValues}
            params={initParams}
            entityKey="statAssignVisit/byTeamDate"
            pageSize={500}
            rowActionWidth={0}
            cols={cols}
          />
        </TabPane>
      </Tabs>
    </>
  );
}
